import { useEffect, useState } from 'react'

import { LoadingStates } from '@pb/utils'
import { useSelector, useDispatch } from 'react-redux'

import { PAYMENTS_CONTAINER_PREFIX } from 'features/klarna/constants'
import { setPaymentsLoadStatus } from 'features/klarna/duck/actions'
import selectors from 'features/klarna/duck/selectors'

const useKlarnaPayments = (): any => {
  const dispatch = useDispatch()
  const [loadData, setLoadData] = useState<any>(null)
  const paymentsInitStatus = useSelector(selectors.getPaymentsInitStatus)

  useEffect(() => {
    if (loadData && paymentsInitStatus === LoadingStates.LoadedSuccess) {
      const { paymentMethodCategory, newSessionDetails } = loadData

      Klarna.Payments.load(
        {
          container: `#${PAYMENTS_CONTAINER_PREFIX}${paymentMethodCategory}`,
          payment_method_category: paymentMethodCategory,
        },
        newSessionDetails,
        ({ show_form: showForm, error }) => {
          dispatch(setPaymentsLoadStatus({ paymentMethodCategory, showForm, error }))
        },
      )
    }
  }, [loadData, paymentsInitStatus])

  return {
    load: setLoadData,
  }
}

export default useKlarnaPayments
